module.exports = __webpack_public_path__ + "img/mb_bg.ad56831.webp";